import React from "react";
import PropTypes from "prop-types";
import { Form } from "antd";
import cx from "classnames";
import { fieldGenerator, getErrorOnField } from "utilities/form";
import { OrderedMap } from "immutable";
import "styles/form.css";
import CaseService from "services/case-service";
import { INPUT_TYPES } from "constants";
// const FormItem = Form.Item;

const FORM_FIELDS = new OrderedMap({
    action_reason_category: {
        type: INPUT_TYPES.SELECT,
        placeholder: "Hold Reason Category",
        rules: [
            // {
            //     required: true,
            //     message: "Please Select atleast 1 reason"
            // }
        ],
        options: []
    },
    action_reason_subcategory: {
        type: INPUT_TYPES.SELECT,
        placeholder: "Rejection Reason",
        rules: [],
        options: []
    },
    hold_remarks: {
        type: INPUT_TYPES.TEXTAREA,
        placeholder: "Hold Remarks",
        size: "large",
        rules: [
            {
                required: true,
                message: "Hold remarks are required"
            }
        ],
        onChange: null
    }
});
class HoldModalContent extends React.Component {
    fieldGenerator = fieldGenerator.bind(this.props.form);
    getErrorOnField = getErrorOnField.bind(this.props.form);
    state = {
        actionReasonsList: [],
        hold_remarks: "",
        action_reason: "",
        subCategories: null
    };

    componentDidMount() {
        CaseService.getCategoryWiseReasons(this.props.stageId, 3).then(({ data }) => {
            this.setState({
                actionReasonsList: data
            }, () => this.forceUpdate());
        });
    }

    onChangeRemarks = remarks => {
        this.props.onChange({
            hold_remarks: remarks.target.value,
            action_reason: this.state.action_reason
        });
    };

    onSelectReason = val => {
        this.setState({
            action_reason: this.state.action_reason + ", " +val
        });
    }

    onSelectReasonCategory = val => {
        let reasonCategory = this.state.actionReasonsList && this.state.actionReasonsList.find(_ => _.id == val);
        if(reasonCategory) {
            this.setState({
                action_reason: reasonCategory.name,
                subCategories: !reasonCategory.sub_categories.length ? null : reasonCategory.sub_categories
            });
        }
    }

    enhanceFormFields = () => {
        return FORM_FIELDS
            .setIn(["action_reason_category", "options"], this.state.actionReasonsList.map((_) => ({
                label: _.name,
                value: _.id
            })))
            .setIn(["action_reason_category", "onSelect"], this.onSelectReasonCategory)
            .setIn(["action_reason_subcategory", "options"], this.state.subCategories && this.state.subCategories.map((_) => ({
                label: _.sub_category_name,
                value: _.sub_category_name
            })))
            .setIn(["action_reason_subcategory", "onSelect"], this.onSelectReason)
            .setIn(["hold_remarks", "onChange"], this.onChangeRemarks);
    }

    render() {
        this.fields = this.enhanceFormFields();
        return (
            <React.Fragment>
                <Form hideRequiredMark={false} className={cx("form", "br-3")}>
                    <div className={"form-row"} style={{ display: "block" }}>
                        {this.fields
                            .filter((_, k) => 
                                (!this.state.actionReasonsList || !this.state.actionReasonsList.length) ? 
                                    k !== "action_reason_category" : 
                                    _ !== null
                            )
                            .filter((_, k) => !this.state.subCategories ? k !== "action_reason_subcategory" : _ !== null)
                            .map((field, fieldName) => {
                                return this.fieldGenerator(
                                    fieldName,
                                    field,
                                    this.getErrorOnField(fieldName)
                                )();
                            }).toList()
                        }
                    </div>
                </Form>
            </React.Fragment>
        );
    }
}

HoldModalContent.propTypes = {
    onChange: PropTypes.func,
    form: PropTypes.object,
    stageId: PropTypes.number
};

export default Form.create({})(HoldModalContent);
